<template>
    <section class="addresses-list">
        <div class="addresses-item" v-for="pawn in paginatedResult" :key="pawn.id">

            <div class="addresses-item__img">
                <img :src="pawn.photo" alt="" loading="lazy">
            </div>
            <a  class="addresses-item__link" :href="pawn.url"></a>
            <div class="addresses-item__info">
                <div class="ai-info">
                    <div class="ai-info__address">
                        <p>{{ pawn.city }}</p><span>{{ pawn.street }}, {{ pawn.house }}</span>
                    </div>
                    <div class="ai-info__contact">
                        <template v-if="Array.isArray(pawn.phone)">
                            <a v-for="(item, index) in pawn.phone" :key="index" :href="`tel:${item}`">{{ item }}</a>
                        </template>
                        <a v-else :href="`tel:${pawn.phone}`">{{ pawn.phone }}</a>
                        <p>Режим работы
                            <template v-for="(item, index) in formattedPawnWorkDays(pawn.id)" :key="index">
                                <br>{{item.firstDay}}
                                <template v-if="item.firstDay !== item.lastDay">-{{item.lastDay}}</template>
                                : {{item.schedule}}
                            </template>
                        </p>
                    </div>
                </div>
            </div>

          <div class="addresses-item__stuff">
                <div class="ai-stuff">
                    <div class="ai-stuff__list" v-if="pawn.accepts.length">
                        <div class="ai-stuff__title">Что принимаем</div>
                        <div class="ai-stuff__item" v-for="accept in pawn.accepts" :key="accept.id">{{
                                accept.name
                            }}
                        </div>
                    </div>
                    <div class="ai-stuff__list" v-if="pawn.sales.length">
                        <div class="ai-stuff__title">Акции и распродажи</div>
                        <div class="ai-stuff__item" v-for="sale in pawn.sales" :key="sale.id">{{
                                sale.name
                            }}
                        </div>
                    </div>
                    <div class="ai-stuff__icons" v-if="pawn.accepts.length">
                        <div class="ai-stuff__icon" v-for="accept in pawn.accepts" :key="accept.id"><img
                            :src="accept.icon" loading="lazy" alt=""></div>
                    </div>
                </div>
            </div>
            <div class="addresses-item__actions">
                <div class="ai-actions">
                    <div class="ai-actions__top">
                        <div class="ai-actions__review" @click="openReviewPopup(pawn)">Оставить отзыв</div>
                        <div class="ai-actions__question" @click="openQuestionPopup(pawn)">Задать вопрос</div>
                    </div>
                    <div class="ai-actions__btn">
                        <button class="btn trans" @click="buildRoute({pawnData: pawn})">Построить маршрут</button>
                    </div>
                </div>
            </div>

        </div>
        <PaginationList v-if="total > pageLimit" :current-page="currentPage" :limit="pageLimit" :count="+total" @changePage="changePage"/>
    </section>

    <!--	<vue-awesome-paginate v-if="total > 10" :total-items="total" :items-per-page="limit" :max-pages-shown="5" :showBreakpointButtons="false" :hidePrevNextWhenEnds="true" :current-page="1" :type="'link'" :linkUrl="'[page]'" :on-click="onClickHandler" :numberButtonsClass="'pagination__item'" :active-page-class="'active'" :paginateButtonsClass="''" :back-button-class="'pagination__prev'" :next-button-class="'pagination__next'" :paginationContainerClass="'pagination'" :prevButtonContent="'Назад'" :nextButtonContent="'Вперед'"/>-->

    <teleport to=".popups">
        <PopupPawnReview :pawn-data="selectedPawnshop"/>
        <PopupPawnQuestion :pawn-data="selectedPawnshop"/>
    </teleport>

</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import PopupPawnReview from "@/components/Popups/PopupPawnReview";
import PopupPawnQuestion from "@/components/Popups/PopupPawnQuestion";
import PaginationList from "@/components/utils/PaginationList.vue";

export default {
    name: "PawnshopsList",
    components: {PaginationList, PopupPawnQuestion, PopupPawnReview},
    emits: ['makeRoute'],
    data() {
        return {
            popupQuestionOpened: false,
            popupReviewOpened: false,
            selectedPawnshop: null,
            pageLimit: 5,
            currentPage: 1,
            protocol: location.protocol,
        }
    },
    props: {
        sitesdata: {
            type: Object,
            required: true
        }
    },
    computed: {

        paginatedResult() {
            // if (this.pawnsList. <= this.pageLimit) return this.filteredFaq
            return this.pawnsList.slice((this.currentPage - 1) * this.pageLimit, this.pageLimit * this.currentPage);
        },
        limit() {
            return this.getPawnsFilterKey('limit')
        },
        offSet: {
            get() {
                return this.getPawnsFilterKey('offset')
            },
            set(value) {
                this.setPawnsFiltersKey({key: 'offset', value: value})
            },
        },
        total() {
            return this.getPawnsTotal
        },
        ...mapGetters({
            pawnsList: 'pawns/getPawnsList',
            pawnWorkDays: 'pawns/getPawnWorkDays',
            getPawnsFilterKey: 'pawns/getPawnsFilterKey',
            getPawnsTotal: 'pawns/getPawnsTotal',
            getPawnFormattedWorkDays: 'pawns/getPawnFormattedWorkDays'
        }),
    },
    methods: {
        formattedPawnWorkDays(pawnId) {
            return this.getPawnFormattedWorkDays(pawnId)
        },
        onClickHandler(page) {
            this.offSet = this.limit * (page - 1)
        },
        openReviewPopup(pawnObj) {
            this.popupReviewOpened = true
            this.selectedPawnshop = pawnObj
            window.fancyboxConstructor.show([{src: "#popup-pawn-review", type: "inline"}], {
                Toolbar: false,
                dragToClose: false,
                Thumbs: false,
                closeButton: "outside",
                autoFocus: false,
                mainClass: "fancybox-modal",
                showClass: "fancybox-zoomIn",
                hideClass: "fancybox-zoomOut",
                trapFocus: false,
                click: (fancybox) => {
                    fancybox.close()
                },
                on: {
                    destroy: () => {
                        this.popupReviewOpened = false
                        this.selectedPawnshop = null
                    }
                }
            })
        },
        openQuestionPopup(pawnObj) {
            this.popupQuestionOpened = true
            this.selectedPawnshop = pawnObj
            window.fancyboxConstructor.show([{src: "#popup-pawn-question", type: "inline"}], {
                Toolbar: false,
                dragToClose: false,
                Thumbs: false,
                closeButton: "outside",
                autoFocus: false,
                mainClass: "fancybox-modal",
                showClass: "fancybox-zoomIn",
                hideClass: "fancybox-zoomOut",
                trapFocus: false,
                click: (fancybox) => {
                    fancybox.close()
                },
                on: {
                    destroy: () => {
                        this.popupQuestionOpened = false
                        this.selectedPawnshop = null
                    }
                }
            })
        },
        changePage(newPage) {
            this.currentPage = newPage
        },
        ...mapActions({
            loadPawnsList: 'pawns/loadPawnsList',
            buildRoute: 'pawns/buildRoute'
        }),
        ...mapMutations({
            setPawnsFiltersKey: 'pawns/setPawnsFiltersKey'
        })
    }
}
</script>

<style scoped>

</style>